import { Router, RouterOutlet } from '@angular/router';
import { HeaderComponent } from './header/header.component';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { ItDropdownModule, ItFormModule, ItListModule } from 'design-angular-kit';
import { MatMenuModule } from '@angular/material/menu';
import { MatTableModule } from '@angular/material/table';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatSortModule } from '@angular/material/sort';
import {MediaMatcher} from '@angular/cdk/layout';
import {ChangeDetectorRef, Component, OnDestroy, inject} from '@angular/core';
import {MatListModule} from '@angular/material/list';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {MatToolbarModule} from '@angular/material/toolbar';
import { SicotService } from './sicot.service';
import { CommonModule } from '@angular/common';
import { OAuthService } from 'angular-oauth2-oidc';
import { environment } from '../environments/environment';
import { appVersion } from '../version';
import { Title } from '@angular/platform-browser';


@Component({
    selector: 'app-root',
    imports: [
        CommonModule,
        RouterOutlet,
        HttpClientModule,
        HeaderComponent,
        FormsModule,
        ItDropdownModule,
        ItFormModule,
        ItListModule,
        MatTableModule,
        MatMenuModule,
        MatSortModule,
        MatToolbarModule, MatButtonModule, MatIconModule, MatSidenavModule, MatListModule
    ],
    templateUrl: './app.component.html',
    styleUrl: './app.component.css'
})
export class AppComponent implements OnDestroy {

  ngOnInit(): void {
    this.title.setTitle(`SI-COT v${appVersion.version} (${appVersion.commit})`);
    console.log(environment.redirect_url)
    console.log(environment.client_id)
    console.log(environment.issuer)
    this.oAuthService.loadDiscoveryDocumentAndTryLogin().then(() => {
      if (this.oAuthService.hasValidAccessToken()) {
        const claims = this.oAuthService.getIdentityClaims() as Record<string, unknown> | null;
        if (claims) {
          const username = (claims['username'] ?? claims['preferred_username'] ?? claims['name'] ?? claims['sub']) as string | undefined;
          const userId = (claims['sub']) as string | undefined;
          if (username && userId) {
            this.siCotService.login(username, userId);
          }
        }
      } else {
        this.login();
      }
    });
  }

  constructor(
    private siCotService: SicotService,
    private router: Router,
    private oAuthService: OAuthService,
    private title: Title
  ) {
    const changeDetectorRef = inject(ChangeDetectorRef);
    const media = inject(MediaMatcher);

    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  isAuthorized = this.oAuthService.hasValidAccessToken();

  login() {
    this.oAuthService.initLoginFlow();
  }

  logout() {
    this.oAuthService.revokeTokenAndLogout();
  }

  mobileQuery: MediaQueryList;

  fillerNav = Array.from({length: 10}, (_, i) => `Nav Item ${i + 1}`);

  fillerContent = Array.from(
    {length: 50},
    () =>
      `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
       labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco
       laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in
       voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat
       cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.`,
  );

  private _mobileQueryListener: () => void;

  

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

  isLogged():boolean{
    return this.siCotService.isAuthenticated();
  }

  shouldRun = /(^|.)(stackblitz|webcontainer).(io|com)$/.test(window.location.host);


  goRichieste(){
    this.router.navigate(['/richieste']);
  }

  goNotifiche(){
    this.router.navigate(['/notifiche']);
  }

}